/**
 * Settings keys used for remote config and localStorage.
 */
export enum SETTINGS_KEYS {
    THEME = "THEME",
    COLOR_SCHEME = "COLOR_SCHEME",
    LANGUAGE = "LANGUAGE",
    DATE_FORMAT = "DATE_FORMAT",
    TIME_FORMAT = "TIME_FORMAT",
    SIDEBAR_COLLAPSED = "SIDEBAR_COLLAPSED",
}
